import { render, staticRenderFns } from "./ListTransport.vue?vue&type=template&id=701fe58a&scoped=true&"
import script from "./ListTransport.vue?vue&type=script&lang=js&"
export * from "./ListTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701fe58a",
  null
  
)

export default component.exports